import { useState, useCallback, useEffect } from "react";

export default ({
	fetchOnStart = false,
	initialLoading = false,
	initial,
	transform,
	promise,
	onError,
}) => {
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(initialLoading);
	const [loaded, setLoaded] = useState(false);
	const [response, setResponse] = useState(null);
	const [error, setError] = useState(null);
	const [data, setData] = useState(initial || null);

	const process = useCallback(
		(...args) => {
			setResponse(null);
			setError(null);
			setLoading(true);
			setReady(false);
			return promise(...args)
				.then((resp) => {
					setResponse(resp);
					if (resp?.status === 204 || resp?.result?.status === 204) {
						setData(initial);
						setReady(true);
						return initial;
					}
					// if (merge === false) {
					// 	setData(resp?.data || {});
					// } else {
					// 	// const newContent = mergeDeep(initial, resp?.data || {});
					// 	const newContent = {
					// 		...(initial || {}),
					// 		...(resp?.data || {}),
					// 	};
					// 	console.log({
					// 		raz: initial || {},
					// 		dwa: resp?.data || {},
					// 		newContent,
					// 	});
					// 	setData(newContent);
					// }
					setData(
						typeof transform === "function"
							? transform(initial, resp?.data)
							: resp?.data
					);

					setReady(true);
					return resp?.data;
				})
				.catch((error) => {
					setReady(false);
					setData(initial || null);

					if (typeof onError === "function") {
						return Promise.resolve(
							onError(error, error?.response || {})
						);
					}

					return Promise.reject(error);
				})
				.catch((error) => {
					setResponse(error); // zmieniono z response na err
					setError(error);

					// NOTE(Przemek): Do we really need to throw "unhandled rejection?"
					// since we are already processing the state internally, here.
					return Promise.reject(error);
				})
				.finally(() => {
					setLoading(false);
					setLoaded(true);
				});
		},
		// eslint-disable-next-line
		[promise]
	);

	const loadingContainerProps = {
		loading,
		error,
		response,
		onErrorButtonClick: process,
		ready,
	};

	useEffect(() => {
		if (fetchOnStart === true) {
			process();
		}
		// eslint-disable-next-line
	}, [fetchOnStart]);

	const reset = () => {
		setData(initial || null);
	};

	return {
		loadingContainerProps,
		ready,
		loading,
		error,
		response,
		data,
		process,
		reset,
		loaded,
	};
};
